import { render, staticRenderFns } from "./Why.vue?vue&type=template&id=6e1980ee&scoped=true&"
import script from "./Why.vue?vue&type=script&lang=js&"
export * from "./Why.vue?vue&type=script&lang=js&"
import style0 from "./Why.vue?vue&type=style&index=0&id=6e1980ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1980ee",
  null
  
)

export default component.exports